import axios from "axios";
import type { StatsDto } from "@/models/dto/statsDto";
import type { RiskStatsDto } from "@/models/dto/riskStatsDto";
import type { RiskCategory } from "@/models/enum/riskCategory";
import type { UnitProfileInfoDto } from "@/models/dto/unitProfileInfoDto";
import type { StatsSummaryDto } from "@/models/dto/statsSummaryDto";

export const getStats = async (questionnaireId: string): Promise<StatsDto> => {
  const response = await axios.get("/api/stats", {
    params: {
      questionnaireId: questionnaireId,
    },
  });
  return response.data;
};

export const getRiskStats = async (
  questionnaireId: string,
  riskCategory: RiskCategory
): Promise<RiskStatsDto[]> => {
  const response = await axios.get("/api/stats/risk-stats", {
    params: {
      questionnaireId: questionnaireId,
      riskCategory: riskCategory,
    },
  });
  return response.data;
};

export const getStatsSummary = async (
  questionnaireId: string
): Promise<StatsSummaryDto> => {
  const response = await axios.get("/api/stats-summary", {
    params: {
      questionnaireId: questionnaireId,
    },
  });
  return response.data;
};

export const getUnitProfileInfo = async (
  questionnaireId: string,
  trustGroupId: string
): Promise<UnitProfileInfoDto> => {
  const response = await axios.get("/api/stats/unit-profile-info", {
    params: {
      questionnaireId: questionnaireId,
      receiverTrustGroupId: trustGroupId,
    },
  });
  return response.data;
};

export const getUnitProfileInfoFromContextId = async (
  questionnaireId: string,
  contextId: string
): Promise<UnitProfileInfoDto> => {
  const response = await axios.get("/api/stats/unit-profile-info-contextid", {
    params: {
      questionnaireId: questionnaireId,
      contextId: contextId,
    },
  });
  return response.data;
};

export const updateAllStats = async (
): Promise<void> => {
  await axios.post("/api/stats/update-all-stats");
};